const moduleSelectedConsultation = {
    namespaced: true,
    state: {
        selectedConsultation: {},
    },
    getters: {
        getSelectedConsultation(state) {
            return state.selectedConsultation;
        },
    },
    mutations: {
        setSelectedConsultation(state, selectedConsultation) {
            state.selectedConsultation = selectedConsultation;
        },       
    },  
}

export default moduleSelectedConsultation;